export type RoleImage = { publicId: string; alt: string }

/**
 * Cloudinary imagery for market role pages, keyed by role. Several skills and
 * skill groups share one photo, so the alt lives here once — same image, same alt.
 */
export const ROLE_IMAGES = {
  baker: {
    publicId: 'photography/markets/baker-image',
    alt: 'Baker holding a tray of freshly baked pastries.',
  },
  lineCook: {
    publicId: 'photography/markets/poloroid-line-cook',
    alt: 'Line cook preparing ingredients at a stainless steel kitchen station.',
  },
  bartender: {
    publicId: 'photography/markets/poloroid-bartender-full-service',
    alt: 'Two bartenders smiling while holding freshly made cocktails at a bar.',
  },
  server: {
    publicId: 'photography/markets/poloroid-foh-support',
    alt: 'Server holding a tray of plated appetizers.',
  },
  dishwasher: {
    publicId: 'photography/markets/poloroid-dishwasher',
    alt: 'Dishwasher in gloves cleaning a dish at a kitchen sink.',
  },
  housekeeping: {
    publicId: 'photography/markets/poloroid-housekeeping',
    alt: 'Housekeeper wiping down a mirror with a cloth.',
  },
  maintenance: {
    publicId: 'photography/markets/poloroid-maintenance',
    alt: 'Maintenance worker holding a cordless power drill.',
  },
  gigsCollage: {
    publicId: 'photography/markets/gigs-all-results-poloroid',
    alt: 'A collage of hospitality workers on the job.',
  },
} as const satisfies Record<string, RoleImage>
